
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13406',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13406",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1006",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10055",
  "foundations-components": "static-1.8646",
  "foundations-components-legacy": "static-1.1671",
  "foundations-theming": "static-1.4887",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.92",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8447",
  "hub-http-shared-msw-handlers": "static-1.10789",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11900",
  "I18n": "static-7.1691",
  "jasmine-runner": "static-1.6856",
  "marketplace-discovery-studio-lib": "static-1.801",
  "marketplace-storefront-base": "static-1.13469",
  "quartz": "static-1.7580",
  "react-dlb": "static-1.92",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "static-1.3260",
  "reporting-testing-lib": "static-1.11088",
  "reselect": "static-3.15",
  "settings-ui-lib": "static-1.12937",
  "SharedI18nStrings": "static-1.186",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7760",
  "ui-addon-i18n": "static-1.11555",
  "ui-addon-react-router-dom": "static-1.9938",
  "unified-auth": "static-1.1122",
  "unified-auth-core-lib": "static-1.1404",
  "usage-tracker": "static-1.7722",
  "usage-tracker-core": "static-1.7572",
  "customer-data-property-utils": "static-1.8464",
  "hub-http": "static-1.6618",
  "integrations-lib": "static-1.17288",
  "marketplace-ui-common": "static-1.20944",
  "marketplace-ui-install": "static-1.930",
  "property-management-iframe": "static-1.14334",
  "quartz-config": "static-1.1358",
  "quartz-core": "static-1.6799",
  "quartz-routing": "static-1.1010",
  "quick-fetch": "static-1.4189",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5076",
  "ts-schema": "static-1.4358",
  "ui-universal-auth": "static-1.9608",
  "UIComponents": "static-3.8846",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3857",
  "quartz-webpack": "static-1.3804",
  "bend-plugin-quartz-routing": "static-1.658",
  "ai-components-ui-library": "static-1.9911",
  "codemirror": "static-5.105",
  "foundations-assets": "static-1.5295",
  "pulse": "static-1.1047",
  "react-codemirror": "static-1.11048",
  "ui-extensions-preview-lib": "static-1.806",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4915",
  "floating-ui": "static-1.66",
  "foundations-theming-specialty": "static-1.2603",
  "framer-motion": "static-1.82",
  "hs-story-utils": "static-1.9834",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.88",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5620",
  "react-virtualized": "static-2.110",
  "StyleGuideUI": "static-3.512",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2929",
  "ui-fonts": "static-1.1162",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3370",
  "foundations-theming-base": "static-1.3872",
  "stylex": "static-1.45",
  "HeadJS": "static-2.811",
  "hs-test-utils-bend-plugin": "static-1.3558",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4717",
  "ui-addon-video-player": "static-1.9057",
  "ai-rendering-library": "static-1.11289",
  "chirp-fetch": "static-1.2308",
  "connections-embed-lib": "static-1.1654",
  "copilot-toolkit": "static-1.12031",
  "feedback-loader": "static-1.29962",
  "laboratory-lib": "static-3.7559",
  "marketplace-embed": "static-1.23090",
  "marketplace-ui-details": "static-1.10839",
  "marketplace-ui-reviews": "static-1.20899",
  "marketplace-ui-tracking": "static-1.15114",
  "sanitize-text": "static-1.8566",
  "usage-tracker-multi": "static-1.6136",
  "usage-tracker-session-replay": "static-1.5408",
  "wootric-nps": "static-1.7260",
  "quartz-head": "static-1.1245",
  "web-vitals": "static-1.18",
  "apollo-link-hub-http": "static-2.5019",
  "immer": "static-1.104",
  "immerable": "static-1.4551",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2773",
  "reporting-data": "static-1.69155",
  "cssUtils": "static-1.1029",
  "flux-actions": "static-1.378",
  "react-colorpicker": "static-2.10620",
  "react-dnd-compat": "static-1.5020",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10779",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7712",
  "icons": "static-2.699",
  "marketplace-ui-apps-core": "static-1.19476",
  "storybook-react": "static-1.43",
  "trellis-story-utils": "static-1.4915",
  "foundations-components-test-utils": "static-1.6129",
  "quartz-i18n": "static-1.1255",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.652",
  "ads-unified-auth-lib": "static-1.1743",
  "custom-vendor-connection-lib": "static-1.172",
  "google-sheets-integration-lib": "static-1.1216",
  "microsoft-drive-auth-lib": "static-1.379",
  "surveymonkey-integration-lib": "static-1.747",
  "slack-ui-library": "static-1.10806",
  "fsm": "static-1.4162",
  "customer-data-objects": "static-1.8101",
  "property-translator": "static-1.5789",
  "hs-locale-management": "static-1.358",
  "frontend-preferences-client": "static-1.8327",
  "hs-promise-utils": "static-1.5998",
  "hubspot-apollo-client": "static-1.5283",
  "integrations-error-boundary-lib": "static-1.14703",
  "integrations-tracking-lib": "static-1.6019",
  "native-integrations-shared-strings": "static-1.8171",
  "sanitize": "static-1.4880",
  "superstore": "static-1.5167",
  "ui-shepherd-react": "static-3.10682",
  "ai-settings-ui-library": "static-1.8480",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4924",
  "immutable-less": "static-1.5058",
  "marketplace-ui-client-types": "static-1.18351",
  "nav-meta": "static-1.30679",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18505",
  "ui-product-approvals-common": "static-1.1403",
  "ai-studio-lib": "static-1.12625",
  "hubspot-prosemirror": "static-1.19166",
  "integrations-reconnect-lib": "static-1.627",
  "ui-addon-iframeable": "static-1.9487",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-product-approvals": "static-1.29508",
  "ui-tool-access": "static-1.10564",
  "inbound-db-properties-service-client": "static-1.4106",
  "property-management-common": "static-1.6622",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.4",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "static-1.1255",
  "quartz-test": "static-1.1255",
  "quartz-tracking": "static-1.959",
  "trellis-components": "static-1.2948",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.486",
  "HubStyle": "static-2.12207",
  "bender-build-tools": "static-1.3472",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.109",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23466",
  "ContentUtils": "static-1.69329",
  "customer-data-objects-ui-components": "static-1.13438",
  "sassPrefix": "static-1.297",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.550",
  "batch-promise": "static-1.1954",
  "event-emitter": "static-1.1368",
  "fast-json-patch": "static-1.73",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5845",
  "magpie-types": "static-1.5305",
  "stylex-utils": "static-1.158",
  "trellis-theming": "static-1.1389",
  "avatar-components": "static-1.2892",
  "breeze-engine-core": "static-1.1271",
  "breeze-onboarding-components": "static-1.942",
  "customer-data-filters-ui": "static-1.41198",
  "customer-data-reference-ui-components": "static-1.13575",
  "data-integrations-breeze": "static-1.164",
  "embedded-academy-lib": "static-1.15817",
  "ExportDialog": "static-6.10783",
  "global-styles-ai-lib": "static-1.347",
  "highlight.js": "static-1.89",
  "marketplace-embed-ba": "static-1.793",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42258",
  "reporting-snowflake": "static-1.57771",
  "reporting-ui-components": "static-2.66424",
  "reporting-visualizations": "static-1.61229",
  "trial-components-library": "static-1.14287",
  "ui-addon-teams": "static-1.21968",
  "upgrade-components-lib": "static-1.645",
  "navigation-components": "static-1.19042",
  "breeze-engine-lib": "static-1.1993",
  "simple-logging-lib": "static-1.3461",
  "nudge-client-utils": "static-1.3303",
  "fail-safe": "static-1.361",
  "app-governance-lib": "static-1.2572",
  "developer-experience-shared-components": "static-1.10946",
  "purchase-motions-components": "static-1.6553",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10601",
  "usage-tracker-anonymous": "static-1.6139",
  "usage-tracker-public": "static-1.7533",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3738",
  "persist-promise": "static-1.4111",
  "reference-resolvers": "static-1.8589",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4325",
  "hubspot-apollo-cache": "static-1.742",
  "universal-page-editor-lib": "static-1.3419",
  "final-form": "static-1.81",
  "redux-toolkit": "static-1.81",
  "simple-data-table": "static-1.3709",
  "merchandise-lib": "static-1.283",
  "onboarding-scopes": "static-1.6860",
  "ui-addon-draggable": "static-3.5154",
  "content-assistance-lib": "static-1.8333",
  "content-media-capture": "static-1.5658",
  "customer-data-ui-utilities": "static-1.10240",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24727",
  "growth-payments-core": "static-1.26380",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3296",
  "payment-link-components": "static-1.24312",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20457",
  "ui-addon-emoji-picker": "static-1.10276",
  "ui-business-units-lib": "static-1.9504",
  "video-components-external": "static-1.12317",
  "video-data-lib": "static-1.35975",
  "navigation-messaging": "static-1.8369",
  "collaboration-sidebar": "static-1.58929",
  "trellis-ext-dnd": "static-1.443",
  "crm-component-utils": "static-1.40045",
  "crm-properties-common-lib": "static-1.6297",
  "customer-data-properties": "static-1.52863",
  "external-options-client-types": "static-1.4406",
  "framework-data-schema-resolvers": "static-1.7304",
  "property-value-citations": "static-1.3477",
  "reference-resolvers-lite": "static-1.8513",
  "hubspotter-http-shared-msw-handlers": "static-1.10787",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "cms-field-types": "static-1.5221",
  "content-icons-ui": "static-1.2417",
  "atom": "static-1.5486",
  "idb-keyval": "static-1.54",
  "reactive-lib": "static-1.1131",
  "breeze-artifacts-sdk": "static-1.656",
  "getting-started-shared-tasks": "static-1.19447",
  "onboarding-journeys-lib": "static-1.1127",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43972",
  "customer-data-filters-ui-msw-helpers": "static-1.23633",
  "events-data-lib": "static-1.656",
  "FormUrlGenerator": "static-2.5121",
  "framework-builder-read-service-client": "static-1.4286",
  "hs-resources": "static-1.603",
  "multi-account-reference-resolvers": "static-1.1411",
  "onboarding-tours": "static-1.17294",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14653",
  "segments-client-types": "static-1.11940",
  "academy-common-lib": "static-1.15277",
  "dashboard-lib": "static-1.83133",
  "hubspot-prosemirror-plugins": "static-1.19158",
  "share-with-third-party-component-lib": "static-1.9119",
  "ui-asset-management-lib": "static-1.11511",
  "user-context": "static-1.5476",
  "reporting-plugins": "static-1.10895",
  "reporting-reports": "static-1.68831",
  "hubs-service-types": "static-1.1672",
  "purchase-motions-api": "static-1.6556",
  "salesImages": "static-1.667",
  "signup-constants": "static-1.19822",
  "nest": "static-1.644",
  "breeze-engine-chat-components": "static-1.971",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3060",
  "nudge-renderer-utils": "static-1.3379",
  "whisper-core-api": "static-1.7519",
  "bend-plugin-fail-safe": "static-1.312",
  "framework-listing-lib": "static-2.29693",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31632",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8468",
  "onboarding-tours-client": "static-1.5509",
  "one-click-checkout": "static-1.634",
  "platform-infra-nav-components": "static-1.7961",
  "subscription-experience-data-types": "static-1.15356",
  "crm-record-cards-service-types": "static-1.3834",
  "location-customization-utils-lib": "static-1.10303",
  "redux-thunk": "static-2.83",
  "react-flip-move": "static-1.81",
  "ui-coaching-tips": "static-1.29493",
  "content-media-composition-data-lib": "static-1.13462",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4834",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3881",
  "seat-types-lib": "static-1.926",
  "ui-addon-opt": "static-4.8784",
  "commerce-tours-lib": "static-1.6769",
  "growth-onboarding-reliability": "static-1.5491",
  "sales-checkout-service-client": "static-1.3938",
  "data-token-picker": "static-1.17033",
  "FileManagerLib": "static-1.40367",
  "content-media-compositions": "static-2.17469",
  "media-bridge-lib": "static-1.19547",
  "chatspot-widget-iframe": "static-1.23457",
  "collaboration-sidebar-common": "static-1.3726",
  "marketing-platform-lib": "static-1.7300",
  "dnd-kit": "static-1.19",
  "card-properties-lib": "static-1.45205",
  "commerce-subscription-lib": "static-1.37979",
  "crm-actions": "static-1.6759",
  "crm-cards-sdk": "static-1.44858",
  "customer-data-properties-shared-msw-handlers": "static-1.10116",
  "customer-data-tracking": "static-1.7281",
  "calling-global-api": "static-1.65966",
  "calling-internal-common": "static-1.31730",
  "calling-lifecycle-internal": "static-1.67348",
  "calling-lifecycle-messages": "static-1.59641",
  "commerce-products-lib": "static-1.10748",
  "conditional-properties-service-client": "static-1.4080",
  "crm-index-visualization-core": "static-1.4668",
  "crm-links": "static-1.6710",
  "crm-pipelines-api-client-types": "static-1.4411",
  "formula-editor": "static-1.14923",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4488",
  "meetings-icalendar-utils-lib": "static-1.1045",
  "multi-currency-client-types": "static-1.3975",
  "object-builder-ui-client": "static-1.49899",
  "pipeline-validation-client-types": "static-1.4247",
  "smart-data-capture-core": "static-1.339",
  "smart-property-lib": "static-1.8510",
  "tiered-pricing": "static-1.2129",
  "topics-actions-lib": "static-1.583",
  "ui-addon-form-validation": "static-1.11337",
  "zustand": "static-1.87",
  "fdsr-migration-layer": "static-1.423",
  "framework-data-schema-quick-fetch": "static-1.7209",
  "restore-request-side-panel-lib": "static-1.1898",
  "growth-data-modal": "static-1.6038",
  "growth-onboarding-confetti": "static-1.3472",
  "growth-onboarding-next-action-utils": "static-1.2873",
  "onboarding-tours-utils": "static-1.1361",
  "ui-shepherd-tracker": "static-1.8063",
  "crm-index-associations-lib": "static-1.6856",
  "academy-service-client": "static-1.4102",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40226",
  "SafeStorage": "static-1.4803",
  "video-embed": "static-1.36809",
  "redux-actions": "static-3.73",
  "EmailSignatureEditor": "static-1.25144",
  "viral-links-lib": "static-1.7488",
  "nested-table": "static-1.645",
  "timezone-utils": "static-2.5639",
  "getting-started-shared-tasks-store": "static-1.18565",
  "campaign-roi-lib": "static-1.10626",
  "campaigns-utils-lib": "static-1.3641",
  "ui-addon-calendars": "static-2.5768",
  "customer-data-views-management": "static-1.26209",
  "framework-data-table": "static-2.12732",
  "nudge-custom-ui-functions": "static-1.1645",
  "switchboard-lib": "static-1.631",
  "access-check-ui-lib": "static-1.1776",
  "app-users-service-client": "static-1.6028",
  "app-users-service-types": "static-1.5436",
  "mini-checkout-client": "static-1.27729",
  "onboarding-utils": "static-1.5778",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29478",
  "checkout-sdk": "static-3.24572",
  "payment-method-components": "static-1.7255",
  "touchless-buying-components": "static-1.6440",
  "upgrade-catalog-service-types": "static-1.3835",
  "edison-service-client-types": "static-1.803",
  "growth-onboarding-feedback-components": "static-1.6992",
  "audio-components": "static-1.6481",
  "FileManagerImages": "static-1.37878",
  "video-components": "static-1.14319",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93067",
  "customer-data-sidebar": "static-2.46911",
  "enrichment-lib": "static-1.767",
  "ui-addon-draggable-compat": "static-2.4671",
  "universal-record-utils-lib": "static-1.2226",
  "commerce-billing-lib": "static-1.20421",
  "commerce-shared-components-lib": "static-1.19461",
  "commerce-tools-ui-lib": "static-1.11216",
  "crm-fe-perf": "static-1.23305",
  "calling-error-reporting": "static-1.31737",
  "shared-worker-versioning": "static-1.11448",
  "calling-usage-tracker": "static-1.6944",
  "voice-sms-access-library": "static-1.2300",
  "commerce-permissions": "static-1.1185",
  "products-iframe-lib": "static-1.8772",
  "products-ui-components-shared-msw-handlers": "static-1.11171",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10872",
  "sales-views-client-types": "static-1.4667",
  "bark-lib": "static-1.16938",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.790",
  "policy-lib": "static-1.7214",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10935",
  "onboarding-data-sync-lib": "static-1.2725",
  "growth-onboarding-next-action-components": "static-1.2901",
  "user-context-client": "static-1.4917",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4924",
  "outpost": "static-1.4543",
  "draft-convert": "static-2.82",
  "draft-extend": "static-3.86",
  "draft-js": "static-5.88",
  "draft-plugins": "static-2.22260",
  "sales-email-signature-service-client": "static-1.4256",
  "ts-utils-lib": "static-1.557",
  "copilot-messaging": "static-1.2281",
  "crm-export-dialog": "static-1.6688",
  "crm-index-ui-shimmer": "static-1.2870",
  "crm-view-components": "static-1.1390",
  "react-beautiful-dnd": "static-1.73",
  "customer-data-associations": "static-1.7739",
  "tasks-actions-lib": "static-1.321",
  "InboxConnectUtils": "static-4.15734",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47033",
  "hub-http-rxjs": "static-1.865",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4400",
  "company-details-components": "static-1.6615",
  "react-performance-metrics-lib": "static-1.963",
  "pricing-pages-ui-components": "static-1.16303",
  "quote-checkout-service-types": "static-1.3866",
  "social-insights-client-types": "static-1.22821",
  "crm_universal": "static-1.22627",
  "customer-data-email": "static-1.18589",
  "card-payment-highlight-lib": "static-1.38191",
  "commerce-contract-lib": "static-1.13625",
  "invoices-highlight-card-lib": "static-1.56035",
  "orders-highlight-card-lib": "static-1.22381",
  "products-highlight-card-lib": "static-1.19031",
  "quotes-highlight-card-lib": "static-1.72976",
  "crm-source-interpretation-lib": "static-1.5738",
  "data-agent-test-utils": "static-1.334",
  "data-agent-utils": "static-1.803",
  "enrichment-settings-lib": "static-1.112",
  "crm-object-search-query-utilities": "static-1.10360",
  "utility-belt": "static-1.2943",
  "payments-enrollment-embed-lib": "static-1.24083",
  "stripe-embedded-components": "static-1.8141",
  "customer-data-rte": "static-1.33796",
  "cv-backend-services": "static-1.1600",
  "growth-onboarding-empty-states": "static-1.6433",
  "payments-post-enroll-local-storage-lib": "static-1.5512",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39066",
  "calling-orchestration-schema": "static-1.37077",
  "react-reducer-toolkit": "static-1.16552",
  "meetings-connect-utils-lib": "static-1.8024",
  "hub-http-contrib": "static-1.3435",
  "ui-addon-sales-email": "static-1.5612",
  "access-control-lib": "static-1.10837",
  "EmailComponents": "static-1.55731",
  "EmailData": "static-1.54409",
  "messaging-base-table-lib": "static-1.691",
  "redux-less": "static-2.9870",
  "company-details-service-types": "static-1.4352",
  "segments-query-core": "static-1.1837",
  "pricing-pages-api": "static-1.16168",
  "sequences-lib": "static-1.8674",
  "ui-gdpr-components": "static-1.10649",
  "products-ui-components": "static-1.41266",
  "reporting-enablement": "static-1.24038",
  "accounting-integrations-ui-components": "static-1.7700",
  "invoices-ui-lib": "static-1.56051",
  "commerce-products-api": "static-1.2826",
  "invoices-iframe-lib": "static-1.58109",
  "quotes-modal-lib": "static-1.103654",
  "quotes-ui-lib": "static-1.81697",
  "stripe-connect-js": "static-1.81",
  "draft-content-plugins": "static-1.29052",
  "ContentComponents": "static-2.72285",
  "ContentData": "static-1.69404",
  "marketing-email-service-types": "static-1.2174",
  "messaging-editing-lib": "static-1.47348",
  "messaging-usage-based-billing-components-lib": "static-1.2210",
  "automation-ui-source-apps": "static-1.19865",
  "automation-ui-types": "static-1.20783",
  "messaging-types-lib": "static-1.47085",
  "onboarding-settings-client": "static-1.4917",
  "sequences-client-types-lib": "static-1.8531",
  "commerce-tax-lib": "static-1.947",
  "price-books-api": "static-1.1913",
  "price-books-components": "static-1.1971",
  "property-description-translator": "static-1.4230",
  "ramp-editor": "static-1.1063",
  "data-quality-ui-library": "static-1.14155",
  "report-customization-components": "static-1.14092",
  "reporting-filters": "static-1.1182",
  "reporting-insights-lib": "static-1.2791",
  "commerce-analytics-service-client": "static-1.3926",
  "totals-ui-components": "static-1.24460",
  "SalesContentIndexUI": "static-3.9688",
  "advanced-menus-core": "static-1.15717",
  "advanced-menus-lib": "static-1.12512",
  "automation-ui-ubb": "static-1.6699",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7747",
  "data-token-views": "static-1.17014",
  "forms-utils-lib": "static-1.13238",
  "payments-embed-points-lib": "static-1.13746",
  "react-tinymce": "static-1.56158",
  "simple-menus-core": "static-1.15716",
  "simple-menus-lib": "static-1.17233",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55284",
  "tinymce-data": "static-1.41369",
  "tinymce-plugins": "static-1.58398",
  "tinymce-themes": "static-1.57254",
  "ui-brand-identity-lib": "static-1.16774",
  "ui-memberships-settings-lib": "static-1.35063",
  "videoconference-integration-components": "static-1.7433",
  "automation-applications-service-types": "static-1.3697",
  "automation-platform-service-types": "static-1.2708",
  "ContentEditorUI": "static-2.78115",
  "content-whatsapp-service-types": "static-1.634",
  "short-messages-app-service-client": "static-1.4332",
  "web-interactives-components": "static-1.14393",
  "web-interactives-data": "static-1.14394",
  "messaging-shared-utils-lib": "static-1.1659",
  "messaging-user-info-utils-lib": "static-1.1829",
  "email-portal-health-service-types": "static-1.1391",
  "line-items-api": "static-1.1233",
  "merge-modal-lib": "static-1.12911",
  "commerce-totals-service-types": "static-1.4097",
  "FireAlarmUi": "static-1.4796",
  "sales-templates-service-types-lib": "static-1.4449",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22719",
  "automation-ui-usage-tracking": "static-1.22182",
  "data-studio-ubb": "static-1.3697",
  "interframe": "static-3.5150",
  "layout-dnd-components": "static-1.13118",
  "layout-dnd-utils": "static-1.12093",
  "NamespacedHubStyle": "static-2.9323",
  "campaigns-lib": "static-1.27792",
  "content-management-data-lib": "static-1.6126",
  "copilot-plugins": "static-1.12003",
  "cta-picker": "static-1.37165",
  "customer-agent-discovery-components-lib": "static-1.4152",
  "editor-components": "static-1.13796",
  "editor-iframe-lib": "static-1.8920",
  "error-messaging-js": "static-1.5555",
  "FormsCommonComponents": "static-1.86735",
  "layout-data-lib": "static-1.10418",
  "pictos": "static-7.194",
  "react-transition-group": "static-2.76",
  "redux-request-state": "static-1.11047",
  "SharedLegalStrings": "static-1.2136",
  "smart-content-core": "static-1.43349",
  "smart-content-lib": "static-1.44002",
  "social-composer-lib": "static-1.60480",
  "structured-content-lib": "static-1.26088",
  "theme-previewer-lib": "static-1.54064",
  "tinymce-copilot": "static-1.17352",
  "xray-recommendation-lib": "static-1.8378",
  "automation-ui-routing": "static-1.22140",
  "sql-reporting-client-types": "static-1.5966",
  "attribution-lib": "static-1.42916",
  "voice-agents-components": "static-1.3969",
  "forms-ai-lib": "static-1.4893",
  "codemirror-dlb": "static-1.59674",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6854",
  "calling-orchestration-shared-library": "static-1.36852"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13406",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1006",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10055",
  "foundations-components": "/foundations-components/static-1.8646",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1671",
  "foundations-theming": "/foundations-theming/static-1.4887",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.92",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8447",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10789",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11900",
  "I18n": "/I18n/static-7.1691",
  "jasmine-runner": "/jasmine-runner/static-1.6856",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.801",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13469",
  "quartz": "/quartz/static-1.7580",
  "react-dlb": "/react-dlb/static-1.92",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3260",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11088",
  "reselect": "/reselect/static-3.15",
  "settings-ui-lib": "/settings-ui-lib/static-1.12937",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7760",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11555",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9938",
  "unified-auth": "/unified-auth/static-1.1122",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1404",
  "usage-tracker": "/usage-tracker/static-1.7722",
  "usage-tracker-core": "/usage-tracker-core/static-1.7572",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8464",
  "hub-http": "/hub-http/static-1.6618",
  "integrations-lib": "/integrations-lib/static-1.17288",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20944",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.930",
  "property-management-iframe": "/property-management-iframe/static-1.14334",
  "quartz-config": "/quartz-config/static-1.1358",
  "quartz-core": "/quartz-core/static-1.6799",
  "quartz-routing": "/quartz-routing/static-1.1010",
  "quick-fetch": "/quick-fetch/static-1.4189",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5076",
  "ts-schema": "/ts-schema/static-1.4358",
  "ui-universal-auth": "/ui-universal-auth/static-1.9608",
  "UIComponents": "/UIComponents/static-3.8846",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3857",
  "quartz-webpack": "/quartz-webpack/static-1.3804",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.658",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9911",
  "codemirror": "/codemirror/static-5.105",
  "foundations-assets": "/foundations-assets/static-1.5295",
  "pulse": "/pulse/static-1.1047",
  "react-codemirror": "/react-codemirror/static-1.11048",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.806",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4915",
  "floating-ui": "/floating-ui/static-1.66",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2603",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-story-utils": "/hs-story-utils/static-1.9834",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5620",
  "react-virtualized": "/react-virtualized/static-2.110",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2929",
  "ui-fonts": "/ui-fonts/static-1.1162",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3370",
  "foundations-theming-base": "/foundations-theming-base/static-1.3872",
  "stylex": "/stylex/static-1.45",
  "HeadJS": "/HeadJS/static-2.811",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3558",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4717",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ai-rendering-library": "/ai-rendering-library/static-1.11289",
  "chirp-fetch": "/chirp-fetch/static-1.2308",
  "connections-embed-lib": "/connections-embed-lib/static-1.1654",
  "copilot-toolkit": "/copilot-toolkit/static-1.12031",
  "feedback-loader": "/feedback-loader/static-1.29962",
  "laboratory-lib": "/laboratory-lib/static-3.7559",
  "marketplace-embed": "/marketplace-embed/static-1.23090",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10839",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20899",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15114",
  "sanitize-text": "/sanitize-text/static-1.8566",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6136",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5408",
  "wootric-nps": "/wootric-nps/static-1.7260",
  "quartz-head": "/quartz-head/static-1.1245",
  "web-vitals": "/web-vitals/static-1.18",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4551",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2773",
  "reporting-data": "/reporting-data/static-1.69155",
  "cssUtils": "/cssUtils/static-1.1029",
  "flux-actions": "/flux-actions/static-1.378",
  "react-colorpicker": "/react-colorpicker/static-2.10620",
  "react-dnd-compat": "/react-dnd-compat/static-1.5020",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10779",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7712",
  "icons": "/icons/static-2.699",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19476",
  "storybook-react": "/storybook-react/static-1.43",
  "trellis-story-utils": "/trellis-story-utils/static-1.4915",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6129",
  "quartz-i18n": "/quartz-i18n/static-1.1255",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.652",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1743",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.172",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1216",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.379",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.747",
  "slack-ui-library": "/slack-ui-library/static-1.10806",
  "fsm": "/fsm/static-1.4162",
  "customer-data-objects": "/customer-data-objects/static-1.8101",
  "property-translator": "/property-translator/static-1.5789",
  "hs-locale-management": "/hs-locale-management/static-1.358",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8327",
  "hs-promise-utils": "/hs-promise-utils/static-1.5998",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5283",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14703",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6019",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8171",
  "sanitize": "/sanitize/static-1.4880",
  "superstore": "/superstore/static-1.5167",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10682",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8480",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4924",
  "immutable-less": "/immutable-less/static-1.5058",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18351",
  "nav-meta": "/nav-meta/static-1.30679",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18505",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1403",
  "ai-studio-lib": "/ai-studio-lib/static-1.12625",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19166",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.627",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9487",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-product-approvals": "/ui-product-approvals/static-1.29508",
  "ui-tool-access": "/ui-tool-access/static-1.10564",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4106",
  "property-management-common": "/property-management-common/static-1.6622",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.4",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "/quartz-auth/static-1.1255",
  "quartz-test": "/quartz-test/static-1.1255",
  "quartz-tracking": "/quartz-tracking/static-1.959",
  "trellis-components": "/trellis-components/static-1.2948",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.486",
  "HubStyle": "/HubStyle/static-2.12207",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.109",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23466",
  "ContentUtils": "/ContentUtils/static-1.69329",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13438",
  "sassPrefix": "/sassPrefix/static-1.297",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.550",
  "batch-promise": "/batch-promise/static-1.1954",
  "event-emitter": "/event-emitter/static-1.1368",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5845",
  "magpie-types": "/magpie-types/static-1.5305",
  "stylex-utils": "/stylex-utils/static-1.158",
  "trellis-theming": "/trellis-theming/static-1.1389",
  "avatar-components": "/avatar-components/static-1.2892",
  "breeze-engine-core": "/breeze-engine-core/static-1.1271",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.942",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41198",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13575",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.164",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15817",
  "ExportDialog": "/ExportDialog/static-6.10783",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.347",
  "highlight.js": "/highlight.js/static-1.89",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.793",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42258",
  "reporting-snowflake": "/reporting-snowflake/static-1.57771",
  "reporting-ui-components": "/reporting-ui-components/static-2.66424",
  "reporting-visualizations": "/reporting-visualizations/static-1.61229",
  "trial-components-library": "/trial-components-library/static-1.14287",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.645",
  "navigation-components": "/navigation-components/static-1.19042",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1993",
  "simple-logging-lib": "/simple-logging-lib/static-1.3461",
  "nudge-client-utils": "/nudge-client-utils/static-1.3303",
  "fail-safe": "/fail-safe/static-1.361",
  "app-governance-lib": "/app-governance-lib/static-1.2572",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10946",
  "purchase-motions-components": "/purchase-motions-components/static-1.6553",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10601",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6139",
  "usage-tracker-public": "/usage-tracker-public/static-1.7533",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3738",
  "persist-promise": "/persist-promise/static-1.4111",
  "reference-resolvers": "/reference-resolvers/static-1.8589",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4325",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.742",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3419",
  "final-form": "/final-form/static-1.81",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "simple-data-table": "/simple-data-table/static-1.3709",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6860",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5154",
  "content-assistance-lib": "/content-assistance-lib/static-1.8333",
  "content-media-capture": "/content-media-capture/static-1.5658",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10240",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24727",
  "growth-payments-core": "/growth-payments-core/static-1.26380",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3296",
  "payment-link-components": "/payment-link-components/static-1.24312",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20457",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10276",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9504",
  "video-components-external": "/video-components-external/static-1.12317",
  "video-data-lib": "/video-data-lib/static-1.35975",
  "navigation-messaging": "/navigation-messaging/static-1.8369",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58929",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.443",
  "crm-component-utils": "/crm-component-utils/static-1.40045",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6297",
  "customer-data-properties": "/customer-data-properties/static-1.52863",
  "external-options-client-types": "/external-options-client-types/static-1.4406",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7304",
  "property-value-citations": "/property-value-citations/static-1.3477",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8513",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10787",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "cms-field-types": "/cms-field-types/static-1.5221",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "atom": "/atom/static-1.5486",
  "idb-keyval": "/idb-keyval/static-1.54",
  "reactive-lib": "/reactive-lib/static-1.1131",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.656",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19447",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1127",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43972",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23633",
  "events-data-lib": "/events-data-lib/static-1.656",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5121",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4286",
  "hs-resources": "/hs-resources/static-1.603",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1411",
  "onboarding-tours": "/onboarding-tours/static-1.17294",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14653",
  "segments-client-types": "/segments-client-types/static-1.11940",
  "academy-common-lib": "/academy-common-lib/static-1.15277",
  "dashboard-lib": "/dashboard-lib/static-1.83133",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19158",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9119",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11511",
  "user-context": "/user-context/static-1.5476",
  "reporting-plugins": "/reporting-plugins/static-1.10895",
  "reporting-reports": "/reporting-reports/static-1.68831",
  "hubs-service-types": "/hubs-service-types/static-1.1672",
  "purchase-motions-api": "/purchase-motions-api/static-1.6556",
  "salesImages": "/salesImages/static-1.667",
  "signup-constants": "/signup-constants/static-1.19822",
  "nest": "/nest/static-1.644",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.971",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3060",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3379",
  "whisper-core-api": "/whisper-core-api/static-1.7519",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.312",
  "framework-listing-lib": "/framework-listing-lib/static-2.29693",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31632",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8468",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5509",
  "one-click-checkout": "/one-click-checkout/static-1.634",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7961",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15356",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10303",
  "redux-thunk": "/redux-thunk/static-2.83",
  "react-flip-move": "/react-flip-move/static-1.81",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29493",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13462",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4834",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3881",
  "seat-types-lib": "/seat-types-lib/static-1.926",
  "ui-addon-opt": "/ui-addon-opt/static-4.8784",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6769",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5491",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3938",
  "data-token-picker": "/data-token-picker/static-1.17033",
  "FileManagerLib": "/FileManagerLib/static-1.40367",
  "content-media-compositions": "/content-media-compositions/static-2.17469",
  "media-bridge-lib": "/media-bridge-lib/static-1.19547",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23457",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3726",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7300",
  "dnd-kit": "/dnd-kit/static-1.19",
  "card-properties-lib": "/card-properties-lib/static-1.45205",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37979",
  "crm-actions": "/crm-actions/static-1.6759",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44858",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10116",
  "customer-data-tracking": "/customer-data-tracking/static-1.7281",
  "calling-global-api": "/calling-global-api/static-1.65966",
  "calling-internal-common": "/calling-internal-common/static-1.31730",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67348",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59641",
  "commerce-products-lib": "/commerce-products-lib/static-1.10748",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4080",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4668",
  "crm-links": "/crm-links/static-1.6710",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4411",
  "formula-editor": "/formula-editor/static-1.14923",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4488",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1045",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3975",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49899",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4247",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.339",
  "smart-property-lib": "/smart-property-lib/static-1.8510",
  "tiered-pricing": "/tiered-pricing/static-1.2129",
  "topics-actions-lib": "/topics-actions-lib/static-1.583",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11337",
  "zustand": "/zustand/static-1.87",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.423",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7209",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1898",
  "growth-data-modal": "/growth-data-modal/static-1.6038",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3472",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2873",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1361",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8063",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6856",
  "academy-service-client": "/academy-service-client/static-1.4102",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40226",
  "SafeStorage": "/SafeStorage/static-1.4803",
  "video-embed": "/video-embed/static-1.36809",
  "redux-actions": "/redux-actions/static-3.73",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25144",
  "viral-links-lib": "/viral-links-lib/static-1.7488",
  "nested-table": "/nested-table/static-1.645",
  "timezone-utils": "/timezone-utils/static-2.5639",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18565",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10626",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3641",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5768",
  "customer-data-views-management": "/customer-data-views-management/static-1.26209",
  "framework-data-table": "/framework-data-table/static-2.12732",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1645",
  "switchboard-lib": "/switchboard-lib/static-1.631",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1776",
  "app-users-service-client": "/app-users-service-client/static-1.6028",
  "app-users-service-types": "/app-users-service-types/static-1.5436",
  "mini-checkout-client": "/mini-checkout-client/static-1.27729",
  "onboarding-utils": "/onboarding-utils/static-1.5778",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29478",
  "checkout-sdk": "/checkout-sdk/static-3.24572",
  "payment-method-components": "/payment-method-components/static-1.7255",
  "touchless-buying-components": "/touchless-buying-components/static-1.6440",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3835",
  "edison-service-client-types": "/edison-service-client-types/static-1.803",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6992",
  "audio-components": "/audio-components/static-1.6481",
  "FileManagerImages": "/FileManagerImages/static-1.37878",
  "video-components": "/video-components/static-1.14319",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93067",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46911",
  "enrichment-lib": "/enrichment-lib/static-1.767",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4671",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2226",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20421",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19461",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11216",
  "crm-fe-perf": "/crm-fe-perf/static-1.23305",
  "calling-error-reporting": "/calling-error-reporting/static-1.31737",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11448",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6944",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2300",
  "commerce-permissions": "/commerce-permissions/static-1.1185",
  "products-iframe-lib": "/products-iframe-lib/static-1.8772",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11171",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10872",
  "sales-views-client-types": "/sales-views-client-types/static-1.4667",
  "bark-lib": "/bark-lib/static-1.16938",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.790",
  "policy-lib": "/policy-lib/static-1.7214",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10935",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2725",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2901",
  "user-context-client": "/user-context-client/static-1.4917",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4924",
  "outpost": "/outpost/static-1.4543",
  "draft-convert": "/draft-convert/static-2.82",
  "draft-extend": "/draft-extend/static-3.86",
  "draft-js": "/draft-js/static-5.88",
  "draft-plugins": "/draft-plugins/static-2.22260",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4256",
  "ts-utils-lib": "/ts-utils-lib/static-1.557",
  "copilot-messaging": "/copilot-messaging/static-1.2281",
  "crm-export-dialog": "/crm-export-dialog/static-1.6688",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2870",
  "crm-view-components": "/crm-view-components/static-1.1390",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.73",
  "customer-data-associations": "/customer-data-associations/static-1.7739",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.321",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15734",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47033",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.865",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4400",
  "company-details-components": "/company-details-components/static-1.6615",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.963",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16303",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3866",
  "social-insights-client-types": "/social-insights-client-types/static-1.22821",
  "crm_universal": "/crm_universal/static-1.22627",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38191",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13625",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56035",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22381",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19031",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72976",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5738",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.334",
  "data-agent-utils": "/data-agent-utils/static-1.803",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.112",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10360",
  "utility-belt": "/utility-belt/static-1.2943",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24083",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8141",
  "customer-data-rte": "/customer-data-rte/static-1.33796",
  "cv-backend-services": "/cv-backend-services/static-1.1600",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6433",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5512",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39066",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37077",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16552",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8024",
  "hub-http-contrib": "/hub-http-contrib/static-1.3435",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5612",
  "access-control-lib": "/access-control-lib/static-1.10837",
  "EmailComponents": "/EmailComponents/static-1.55731",
  "EmailData": "/EmailData/static-1.54409",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.691",
  "redux-less": "/redux-less/static-2.9870",
  "company-details-service-types": "/company-details-service-types/static-1.4352",
  "segments-query-core": "/segments-query-core/static-1.1837",
  "pricing-pages-api": "/pricing-pages-api/static-1.16168",
  "sequences-lib": "/sequences-lib/static-1.8674",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10649",
  "products-ui-components": "/products-ui-components/static-1.41266",
  "reporting-enablement": "/reporting-enablement/static-1.24038",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7700",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56051",
  "commerce-products-api": "/commerce-products-api/static-1.2826",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58109",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103654",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81697",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "draft-content-plugins": "/draft-content-plugins/static-1.29052",
  "ContentComponents": "/ContentComponents/static-2.72285",
  "ContentData": "/ContentData/static-1.69404",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2174",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47348",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2210",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19865",
  "automation-ui-types": "/automation-ui-types/static-1.20783",
  "messaging-types-lib": "/messaging-types-lib/static-1.47085",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4917",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8531",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.947",
  "price-books-api": "/price-books-api/static-1.1913",
  "price-books-components": "/price-books-components/static-1.1971",
  "property-description-translator": "/property-description-translator/static-1.4230",
  "ramp-editor": "/ramp-editor/static-1.1063",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14155",
  "report-customization-components": "/report-customization-components/static-1.14092",
  "reporting-filters": "/reporting-filters/static-1.1182",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2791",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3926",
  "totals-ui-components": "/totals-ui-components/static-1.24460",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9688",
  "advanced-menus-core": "/advanced-menus-core/static-1.15717",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6699",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7747",
  "data-token-views": "/data-token-views/static-1.17014",
  "forms-utils-lib": "/forms-utils-lib/static-1.13238",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13746",
  "react-tinymce": "/react-tinymce/static-1.56158",
  "simple-menus-core": "/simple-menus-core/static-1.15716",
  "simple-menus-lib": "/simple-menus-lib/static-1.17233",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55284",
  "tinymce-data": "/tinymce-data/static-1.41369",
  "tinymce-plugins": "/tinymce-plugins/static-1.58398",
  "tinymce-themes": "/tinymce-themes/static-1.57254",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16774",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35063",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7433",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3697",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2708",
  "ContentEditorUI": "/ContentEditorUI/static-2.78115",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.634",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4332",
  "web-interactives-components": "/web-interactives-components/static-1.14393",
  "web-interactives-data": "/web-interactives-data/static-1.14394",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1659",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1829",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1391",
  "line-items-api": "/line-items-api/static-1.1233",
  "merge-modal-lib": "/merge-modal-lib/static-1.12911",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4097",
  "FireAlarmUi": "/FireAlarmUi/static-1.4796",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4449",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22719",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22182",
  "data-studio-ubb": "/data-studio-ubb/static-1.3697",
  "interframe": "/interframe/static-3.5150",
  "layout-dnd-components": "/layout-dnd-components/static-1.13118",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12093",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9323",
  "campaigns-lib": "/campaigns-lib/static-1.27792",
  "content-management-data-lib": "/content-management-data-lib/static-1.6126",
  "copilot-plugins": "/copilot-plugins/static-1.12003",
  "cta-picker": "/cta-picker/static-1.37165",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4152",
  "editor-components": "/editor-components/static-1.13796",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8920",
  "error-messaging-js": "/error-messaging-js/static-1.5555",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86735",
  "layout-data-lib": "/layout-data-lib/static-1.10418",
  "pictos": "/pictos/static-7.194",
  "react-transition-group": "/react-transition-group/static-2.76",
  "redux-request-state": "/redux-request-state/static-1.11047",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2136",
  "smart-content-core": "/smart-content-core/static-1.43349",
  "smart-content-lib": "/smart-content-lib/static-1.44002",
  "social-composer-lib": "/social-composer-lib/static-1.60480",
  "structured-content-lib": "/structured-content-lib/static-1.26088",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54064",
  "tinymce-copilot": "/tinymce-copilot/static-1.17352",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8378",
  "automation-ui-routing": "/automation-ui-routing/static-1.22140",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5966",
  "attribution-lib": "/attribution-lib/static-1.42916",
  "voice-agents-components": "/voice-agents-components/static-1.3969",
  "forms-ai-lib": "/forms-ai-lib/static-1.4893",
  "codemirror-dlb": "/codemirror-dlb/static-1.59674",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6854",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36852"
}
};
